import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/components/LanguageContext";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import AppFeaturesSection from "@/components/AppFeaturesSection";
import PartnershipsSection from "@/components/PartnershipsSection";
import PricingSection from "@/components/PricingSection";
import ExamesSection from "@/components/ExamesSection";
import CalendarSection from "@/components/CalendarSection";
import FAQSection from "@/components/FAQSection";
import ContactSection from "@/components/ContactSection";
import FooterSection from "@/components/FooterSection";
import PrivacyPolicy from "@/components/PrivacyPolicy";
import AppShowcasePage from "@/components/AppShowcasePage";
import CoursesPage from "@/components/CoursesPage";
import PaymentSuccess from "@/components/PaymentSuccess";

function LandingPage() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <HeroSection />
      <AboutSection />
      <ExamesSection />
      <PartnershipsSection />
      <CalendarSection />
      <FAQSection />
      <ContactSection />
      <FooterSection />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // wait for the page (and any lazy content) to render before scrolling
      const id = hash.slice(1);
      let attempts = 0;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (attempts < 10) {
          attempts += 1;
          setTimeout(tryScroll, 80);
        }
      };
      tryScroll();
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/app" element={<AppShowcasePage />} />
          <Route path="/cursos" element={<CoursesPage />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
